import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  cardContainer: {
    backgroundColor: '#ffffff',
    border: `1px solid ${getRGBA('#000000', 0.2)}`,
    borderRadius: '0.5rem',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '12px',
    cursor: 'pointer',
  },

  title: {
    fontFamily: 'Nunito',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    color: `#191C1A`,
  },

  infoContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  clientInfoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },

  healthPlanContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
  },

  automationsContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '8px',
  },

  automationTitleContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.25rem',
  },

  automationName: {
    fontFamily: 'Sora',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    color: `#8C8C93`,
  },

  projectAutomationsContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '0.35rem',
  },

  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
  },
}))

export { useStyles }
